import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from "@coreui/react";

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { VendorReducer } from "shared/redux/reducers/vendor/VendorReducer";
import $ from "jquery";
import CIcon from "@coreui/icons-react";
import { sygnet } from "components/manager/assets/brand/sygnet";
import SimpleBar from 'simplebar-react'
import VendorSideBarNav from "./VendorSideBarNav";
import { ManagerSidebarNav } from "routes/manager/ManagerSidebarNav";

function VendorSideBar () {
    const sidebar = useRef();
    const dispatch = useDispatch();
    const { sidebarShow, sidebarUnfoldable } = useSelector((state) => ({ sidebarShow: state.vendor.sidebarShow, sidebarUnfoldable: state.vendor.sidebarUnfoldable }));
    const [isVisible, setVisible] = useState(true);

    useEffect(() => {
        const currentSidebar = sidebar.current;
        if (currentSidebar) {
          currentSidebar.addEventListener('transitionend', onSidebarTransitionEnd);
        }
      
        return () => {
          // 이 부분이 중요합니다. 여기에서 currentSidebar를 사용해야 합니다.
          // 이 때 currentSidebar는 언마운트 시에도 여전히 마지막으로 참조된 실제 DOM 요소를 가리킵니다.
          if (currentSidebar) {
            currentSidebar.removeEventListener('transitionend', onSidebarTransitionEnd);
          }
        };
      }, []);

    const onSidebarTransitionEnd = () => {
        let margin = $('.sidebar').outerWidth(true) - $('.sidebar').outerWidth();
        if (margin === 0) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }

    const onSidebarTogglerClick = () => {
        dispatch(VendorReducer.actions.toggleSidebarUnfoldable(!sidebarUnfoldable));
    }


    useEffect(() => {
        setVisible(sidebarShow);
    }, [sidebarShow]);

    useEffect(() => {
        if (isVisible === undefined) {

        } else {
            dispatch(VendorReducer.actions.toggleSideBar(isVisible));
        }
    }, [isVisible]);

    return (
        <CSidebar ref={sidebar} position="fixed" unfoldable={sidebarUnfoldable} visible={sidebarShow}>
            <CSidebarBrand className="d-none d-md-flex" to="/">
                로고자리
                {/* <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} /> */}
                <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
            </CSidebarBrand>
            <CSidebarNav>
                <SimpleBar>
                    <ManagerSidebarNav items={VendorSideBarNav} />
                </SimpleBar>
            </CSidebarNav>
            <CSidebarToggler className="d-none d-lg-flex" onClick={onSidebarTogglerClick} />
        </CSidebar>
    )
}

export default VendorSideBar;